import { render, staticRenderFns } from "./PrimaryHealthAttorneys.vue?vue&type=template&id=60619ac3"
import script from "./PrimaryHealthAttorneys.vue?vue&type=script&lang=js"
export * from "./PrimaryHealthAttorneys.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports